import React, {
  memo,
  useContext,
  useEffect,
  useRef,
} from 'react';
import { useIntl } from 'react-intl';
import Link from '@nubank/nuds-web/components/Link/Link';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import PropTypes from 'prop-types';

import { smoothScroll } from 'utils/domUtils';
import { maybeFormatMessage } from 'utils/i18nUtils';

import QuickNavigationContext from '../../QuickNavigationContext';

import { StyledNavbar } from './style';

const NAV_ITEM_MARGIN = 32;

const Navigation = ({ isVisible, onClick }) => {
  const { formatMessage } = useContext(NuDsContext);

  const { items, selected } = useContext(QuickNavigationContext);
  const navigationRef = useRef();
  const intl = useIntl();

  useEffect(() => {
    const nav = navigationRef.current;
    if (nav && document && selected) {
      const navItemPosition = document.querySelector(`[href="#navigation-item-${selected}"]`).offsetLeft;
      nav.scrollLeft = navItemPosition - NAV_ITEM_MARGIN;
    }
  }, [selected]);

  return (
    <StyledNavbar
      tag="nav"
      ref={navigationRef}
      className={isVisible ? 'visible' : ''}
      aria-label={maybeFormatMessage(intl, 'QUICK_NAV', 'LABEL')}
    >
      {Object.entries(items).map(([id, intlKey], index) => (
        <Link
          className={id === selected ? 'selected' : ''}
          typographyProps={{ variant: 'text1' }}
          color="white"
          href={`#navigation-item-${id}`}
          marginLeft={`${index > 0 ? `${NAV_ITEM_MARGIN}px` : '0x'}`}
          key={id}
          onClick={e => {
            smoothScroll(e);
            if (onClick) {
              onClick(intlKey);
            }
          }}
        >
          {formatMessage({ id: intlKey, optional: true })}
        </Link>
      ))}
    </StyledNavbar>
  );
};

Navigation.defaultProps = {
  onClick: undefined,
};

Navigation.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

export default memo(Navigation);
